<mat-card class="mat-elevation-z8">
    <mat-card-title class="heading">
      <h1>{{data.student_name}} - {{data.student_number}}</h1>
    </mat-card-title>
    <br/>
      <h2 class="subheading"><b>Application Number:</b> {{data.iwa_application_number}}</h2>
    <br/>
   
      <div class="info-container">
        <p class="info-item"><b>Term:</b> {{data.admit_term_description}}</p>
        <p class="info-item"><b>Program code:</b> {{data.program_code}}</p>
        <p class="info-item"><b>Program description:</b> {{data.program_description}}</p>
        <p class="info-item"><b>Campus:</b> {{data.campus_description}}</p>
        <p class="info-item"><b>Date:</b> {{data.action_date}}</p>
        <p class="info-item"><b>Application Status:</b> {{data.reason_description}}</p>
        <p class="info-item"><b>Communications:</b>
          <button *ngIf="data.offer_letter && data.offer_letter !== ' '" type="button" class="letter" mat-button id="uploadButton"
            color="primary" (click)="openOfferLetter(data)">
            Download Communications
          </button>
        </p>
        <p class="info-item"><b>Last Communication Date:</b> {{data.offer_letter}}</p>
   
    </div>
    <br/>

    <mat-card *ngIf="!!chatData && chatData.length">
      <mat-card-title class="heading">
        <h1>Student conversation</h1>
      </mat-card-title>
      <div *ngFor="let chat of chatData">
        <div [innerHTML]="chat.HtmlBody"></div>
      </div>
    </mat-card>
</mat-card>

<div *ngIf="communicationPdfLoading" class="loading-indicator">
  <mat-spinner diameter="100" strokeWidth="15"></mat-spinner>  
</div>
  